import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2'

Vue.use(VueSweetalert2, {
  timer: 4000,
  // position: 'top-end',
  showConfirmButton: true,
})
